import moment from "moment-timezone";

const InstallMoment = (app) => {
  app.config.globalProperties.moment = moment;

  if (typeof window !== "undefined" && window) {
    window.moment = moment;
  }
};

export default InstallMoment;
